import type { HTMLAttributes } from 'react';

export interface SlideshowItemData {
  src: string;
  isVideo?: boolean;
  thumbnail?: string;
  alt?: string;
}

export interface SlideshowData {
  items: SlideshowItemData[];
  index?: number;
  onPrevious?: () => void;
  onNext?: () => void;
  onImageClick?: () => void;
  onThumbnailClick?: (index: number) => void;
  aspectRatio?: number;
}

export interface SlideshowProps extends HTMLAttributes<HTMLDivElement>, SlideshowData {}
